import type { Provider } from '@angular/core';
import { PlatformLocation } from '@angular/common';

import { isNonEmptyString, LoggerService, SESSION_ID } from '@accesso/cc-std-lib';

import type { LocalStorageService } from '../../storage/local-storage.service';
import { QUERY_PARAM_SESSION_ID } from '../../../core/enums/query-params';
import { StorageKey } from '../../storage/storage.keys';
import { StorageService } from '../../storage/storage.token';

export function sessionIdFactory(location: PlatformLocation, storage: LocalStorageService, logger: LoggerService): string {
	const localSessionId = storage.get<string>(StorageKey.SESSION_ID);
	// If it's in local storage
	if (isNonEmptyString(localSessionId)) {
		logger.log(`Using local storage Session ID: ${localSessionId}`);
		return localSessionId;
	}

	const url = new URLSearchParams(location.search);
	const urlSessionId = url.get(QUERY_PARAM_SESSION_ID);
	if (isNonEmptyString(urlSessionId)) {
		logger.log(`Session ID from URL: ${urlSessionId}`);
		storage.add(StorageKey.SESSION_ID, urlSessionId);
		return urlSessionId;
	}

	const newSessionId = crypto.randomUUID();
	logger.log(`Generating new Session ID: ${newSessionId}`);
	storage.add(StorageKey.SESSION_ID, newSessionId);
	return newSessionId;
}

export function provideBrowserSessionId(): Provider {
	return {
		provide: SESSION_ID,
		useFactory: sessionIdFactory,
		deps: [PlatformLocation, StorageService, LoggerService],
	};
}
